import type { Product, ProductRangePrice } from "~/types/Product";
import type { Market } from "./Market";
import type { City } from "./City";
import type { RenewalPeriod } from "./Renewal";
import type { Tax } from "./Tax";
import type { Merchant } from "./Merchant";
import type { Payment } from "./Payment";

export type InvoiceSetting = {
  id: number | null;
  entity_name: string | null;
  logo_path: string | null;
  payment_notice: string | null;
  legal_notice: string | null;
  company_name: string | null;
  company_capital: string | null;
  company_commercial_register: string | null;
  company_intra_vat: string | null;
  company_contact_tel: string | null;
  company_contact_email: string | null;
  IBAN: string | null;
  BIC: string | null;
  uuid_start: number | null;
  uuid_increment: number | null;
  city_id: number | null;
  city: City | null;
  cities: City[] | null;
  siret: string | null;
  code: string | null;
  address: string | null;
  zipcode: string | null;
  cityname: string | null;
  postcode: string | null;
  created_at: string | null;
  updated_at: string | null;
};

export type InvoiceCredit = {
  id: number | null;
  invoice_id: number | null;
  credit_invoice_id: number | null;
  amount: number | null;
};

export type InvoiceDetail = {
  id: number | null;
  amount: number | null;
  amount_excl_tax: number | null | undefined;
  amount_incl_tax: number | null | undefined;
  amount_vat: number | undefined;
  credit_invoice_id: number | null;
  discount_percent: number | null;
  increase_percent: number | null;
  invoice_id: number | undefined | null;
  nb_making: number | null;
  product_accountancy_code: string | null;
  product_accountancy_code_abo: string | null;
  product_accountancy_code_tva: string | null;
  product_code: string | null | undefined;
  product_id: number | null | undefined;
  product_name: string | null | undefined;
  product: Product | null | undefined;
  tax_id: number | null;
  tax: Tax | null;
  total_excl_tax: number | null;
  total_incl_tax: number | null;
  total_vat: number | null | undefined;
  group_id: number | undefined | null;
  sliced_price: number | null;
  groups: InvoiceDetailGroup | null;
  ranges: ProductRangePrice[];
};

export type InvoiceDetailGroup = {
  id: number | null;
  name: string | null;
  location_id: number | null | undefined;
  order: number | null | undefined;
  or_mode: boolean | null | undefined;
};

export type InvoiceDetailGroupLine = {
  invoiceDetailGroup: InvoiceDetailGroup | null;
  list: never[] | Product[] | InvoiceDetail[];
};

export type Invoice = {
  id: number | null;
  uuid: string | null;
  object: string | null;
  comment: string | null;
  comment_visible: string | null;
  total_excl_tax: number;
  total_incl_tax: number;
  total_vat: number;
  due: number;
  invoice_type_id: number | null;
  company_id: number | null;
  merchant_id: number | null;
  subscription_id: number | null;
  placer_id: number | null;
  market: Market | null;
  market_making_id: number | null;
  status: InvoiceStatusType;
  created_at: string | null;
  updated_at: null;
  linked_invoice_id: number | null;
  linked_invoice_uuid: string | null;
  linked_invoice: Invoice | null;
  market_id: number | null;
  merchant_name: string | null;
  merchant_addresse: string | null;
  merchant_comp_addresse: string | null;
  merchant_zipcode: string | null;
  merchant_city: string | null;
  legal_notice_col1: string | null;
  legal_notice_col2: string | null;
  market_date: string | Date | null;
  last_renewal_period: RenewalPeriod | null;
  invoice_details: InvoiceDetail[];
  email_sent: boolean;
  merchant?: Merchant;
  city_id?: number | null;
  entity_id: number | null;
  city?: City | null;
  activity_id?: number | null;
  activity_category_id?: number | null;
  ml_invoiced?: number | null;
  is_extension: boolean;
};

export type InvoicePayment = {
  id: number | null;
  amount: number | null;
  invoice_id: number;
  payment_id: number;
  created_at: string | null;
  updated_at: string | null;
  payment: Payment | null;
  invoice: Invoice | null;
};

export enum InvoiceStatus {
  Draft = 15,
  Unpaid = 16,
  Toclaim = 17,
  Doubtful = 18,
  Uncollectible = 19,
  Paid = 22,
  ToBePaid = 20,
  PartiallyPaid = 21,
  Abandoned = 23,
  Archived = 24,
}
type InvoiceStatusType = `${InvoiceStatus}` | InvoiceStatus;

export enum InvoiceTypeEnum {
  Subscription = 2,
  Ticket = 1,
  Offer = 3,
  Credit = 4,
  Facture = 5,
  OfferTypeSubscription = 6,
  OfferTypeExtension = 7,
  OfferTypeTicket = 8,

}
export type InvoiceType = `${InvoiceTypeEnum}` | InvoiceTypeEnum;
